<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import moment from 'moment';
    import {JIRA_SITE_URL, flagTypes, flagStatus, flagPriority} from '../../constants.js';
    import ComboSelect from '../ComboSelect/ComboSelect.svelte';
    import ReferenceRenderer from './columnRenderer/ReferenceRenderer.svelte';
    import DescriptionRenderer from './columnRenderer/DescriptionRenderer.svelte';
    import DelaySizeRenderer from './columnRenderer/DelaySizeRenderer.svelte';
    import {get, post} from '../../utils.js';
    import {ISSUE_LIST_API, IMPROVEMENT_API} from '../../apiUrls.js';
    import {onMount} from 'svelte';
    import Thumbnail from '../common/Media/Thumbnail.svelte';
    import ReplyReporter from './ReplyReporter.svelte';
    import PriorityRenderer from './columnRenderer/PriorityRenderer.svelte';
    import CodingRenderer from './columnRenderer/CodingRenderer.svelte';
    import NotificationTypeRenderer from './columnRenderer/NotificationTypeRenderer.svelte';
    import Button from '../Button.svelte';
    import EmailLink from '../common/EmailLink.svelte';
    import {sgettext} from '../../i18n.js';

    export let issueId = 0;
    export let canCreateJira;
    export let hasJiraProject = false;
    export let canUpdateIssue = false;
    export let resolveIssueUrl = '';
    export let reopenIssueUrl = '';
    export let showReplyToReporter = false;


    let issue = null;
    let isLinkedToNotification = false;
    let copyingImages = false;
    let selectedImages = [];
    let classificationApi = `${PATH_PREFIX}/sw/api/issue_classifications`;
    let addCommentApi = `${PATH_PREFIX}/sw/common/issue_comment/`;
    let issueClassificationTypes = [];
    let selectedClassification = null;

    const replyReporterModalId = 'replyReporterModal';

    async function getIssueDetails(issueId) {
        if (issueId) {
            const resp = await get(`${ISSUE_LIST_API}${issueId}/`);

            if (resp.ok) {
                issue = await resp.json();
                isLinkedToNotification = checkLinkedToNotification();
            }
        }
    }

    async function getClassifications() {
        const resp = await get(classificationApi);
        const json = await resp.json();
        const result = json['results'];
        issueClassificationTypes = [...result.map(x => ({id: x.id, name: `${sgettext(x.classification_name)}`}))];
        if (issue.classification_id > 0) {
            selectedClassification = issue.classification_id;
        } else {
            selectedClassification = 0;
        }
    }

    function checkLinkedToNotification() {
        let result = false;
        if (issue.linked_issues.length && issue.linked_issues.find(i => i.type === flagTypes.additionalWorkRequired)) {
            result = true;
        }
        return result;
    }

    function getLinkedIssueTitle() {
        let title = '';
        const linked_issue = issue.linked_issues.find(i => i.type === flagTypes.additionalWorkRequired);
        if (linked_issue && linked_issue.title) {
            title = linked_issue.title;
        }
        return title;
    }

    function getElementInActivityLink() {
        let url = '';
        if (issue.activity_version && issue.work_sequence && issue.element_instance) {
            url = `${PATH_PREFIX}/sw/builder/activity_sequence_builder/${issue.activity_version.id}/worksequence/${issue.work_sequence.id}/element_instance/${issue.element_instance.id}/`;
        }
        return url;
    }

    function manageIssue() {
        if (issue.status === flagStatus.open) {
            issue_resolve();
        } else {
            issue_reopen();
        }
    }

    function isSubscribedBySupervisor() {
        if (issue.activity_version && issue.activity_version.sa_subscribers.length) {
            return true;
        }
        return false;
    }

    function getViaText() {
        let text = '';
        if (isSubscribedBySupervisor()) {
            if (issue.linked_issues.find(i => i.type === flagTypes.help)) {
                text = sgettext('$$VIA_SUPERVISOR_ISSUE$$');
            } else if (issue.linked_issues.find(i => i.type === flagTypes.additionalWorkRequired)) {
                text = sgettext('$$VIA_SAP_NOTIFICATION$$');
            }
        }

        return text;
    }

    function getTypeDisplay() {
        let type = `${sgettext('$$IMPROVEMENT$$')}`;

        if (issue.type === flagTypes.help) {
            type = '';
        }

        return type;
    }

    function issue_resolve() {
        jQuery("#modal-iframe").attr("src", resolveIssueUrl);
        jQuery("#modal-title").html(sgettext("$$RESOLVE$$"));
        jQuery("#modal-iframe").attr("height", "400");
        jQuery('#builderModal').modal({show: true, backdrop: 'static', keyboard: false});
    }

    function issue_reopen() {
        jQuery("#modal-iframe").attr("src", reopenIssueUrl);
        jQuery("#modal-title").html(sgettext("$$REOPEN$$"));
        jQuery("#modal-iframe").attr("height", "400");
        jQuery('#builderModal').modal({show: true, backdrop: 'static', keyboard: false});
    }

    function add_comment() {
        jQuery("#modal-iframe").attr("src", addCommentApi+issue.id);
        jQuery("#modal-title").html("Add Comment");
        jQuery("#modal-iframe").attr("height", "400");
        jQuery('#builderModal').modal({show: true, backdrop: 'static', keyboard: false});
    }

    function showReplyReporterModal() {
        jQuery(`#${replyReporterModalId}`).modal('show');
    }

    async function saveClassification() {
        const url = `${IMPROVEMENT_API}${issue.id}/update_issue_classification/`;
        const payload = {};

        if (selectedClassification > 0) {
            payload.classification_id = selectedClassification;
            payload.old_classification = issue.classification;
        }

        if(selectedClassification != issue.classification_id) {
            const resp = await post(url, payload);

            if (resp.ok) {
                const json = await resp.json();
                window.location.reload();
            }
        }
    }

    async function copyImagesToMediaLibrary() {
        const url = `${IMPROVEMENT_API}${issue.id}/copy_to_element_media_library/`;
        const payload = {};

        if (selectedImages.length) {
            payload.flag_image_id = selectedImages;
        }

        copyingImages = true;
        const resp = await post(url, payload);

        if (resp.ok) {
            const json = await resp.json();
        }

        copyingImages = false;
    }

    function getEmailSubject(){
        return `${sgettext('$$IMPROVEMENT_SUBMITTED$$')} ${moment(issue.created_date).format('MMM. DD, YYYY hh:mm a')}`;
    }

    function getEmailBody(){
        // Indentations are removed purposely so that they don't appear in email
        let body = `
__________________________________________________

${sgettext('$$IMPROVEMENT_DETAILS$$')}:

${sgettext('$$DESCRIPTION$$')}: ${issue.value}
${sgettext('$$ELEMENT_1$$')}: ${issue.element_instance ? issue.element_instance.name : ''}
${sgettext('$$SEQUENCE$$')}: ${issue.work_sequence ? issue.work_sequence.name : ''}
${sgettext('$$ACTIVITY_1$$')}: ${issue.activity_name}
${sgettext('$$WORK_ORDER$$')}: ${issue.work_order}
${sgettext('$$SUBMITTED$$')}: ${moment(issue.created_date).format('MMM. DD, YYYY hh:mm a')}
        `;
        return body;
    }

    onMount(async () => {
        await getIssueDetails(issueId);
        await getClassifications();
    });
</script>

<style>
    .wrapper {
        display: grid;
        grid-template-rows: auto auto;
        grid-template-columns: 1fr 0.4fr 0.3fr;

    }

    .wrapper > div.content {
        padding: 20px;
    }

    .card-header.status {
        text-transform: capitalize;
    }

    .issue-container {
        display: flex;
        flex-direction: column;
    }

    .issue-details {
        display: grid;
        grid-template-columns: 150px 1fr;
    }

    .supervisor-info {
        display: grid;
        grid-template-columns: 120px 1fr;
    }

    .classification-info {
        display: grid;
        grid-template-columns: 120px 1fr;
    }

    .action-wrapper {
        display: grid;
        grid-gap: 15px;
    }

    .action-wrapper label {
        font-weight: bold;
    }

    .issue-images {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 15px;
    }

    label {
        font-weight: bold;
    }

    .content.action {
        background-color: white;
    }

    .card-header {
        word-break: break-word;
    }

    .flag-image {
        display: flex;
        position: relative;
        width: 160px;
    }

    .flag-image input {
        position: absolute;
        top: 5px;
        right: 5px;
        transform: scale(1.5);
    }
</style>

{#if issue}
    <div class="wrapper">
        <div class="card-header thead-light">
            <h5 class="mb-0">{getTypeDisplay()} {sgettext('$$RAISED_1$$')}
                {#if issue.user_email}
                <EmailLink
                    label="{issue.user}"
                    email="{issue.user_email}"
                    subject="{getEmailSubject()}"
                    body="{getEmailBody()}"
                />
                {:else}
                    {issue.user}
                {/if}
                {#if isSubscribedBySupervisor()}
                    <span class="text-gray-600">{getViaText()}</span>
                {/if}
            </h5></div>
        <div class="card-header thead-light"><h5 class="mb-0">{sgettext('$$LAST_TRIAGED$$')}
            - {issue.last_triaged_by_email ? issue.last_triaged_by_email : sgettext('$$NONE_ASSIGNED$$')}</h5></div>
        <div class="card-header thead-light status"><h5 class="mb-0">{sgettext('$$STATUS_2$$')} {sgettext(issue.status).toLocaleLowerCase()}</h5>
        </div>
        <div class="issue-container content">
            <div class="issue-details">
                {#if isLinkedToNotification}
                    <div><label>{sgettext('$$TITLE$$')}</label></div>
                    <div><strong>{getLinkedIssueTitle()}</strong></div>
                {/if}
                <div><label>{sgettext('$$DESCRIPTION$$')}</label></div>
                <div>
                    <DescriptionRenderer row="{issue}" detail="{true}" {isLinkedToNotification} isLink="{false}"/>
                </div>
                {#if isLinkedToNotification}
                    <div><label>{sgettext('$$TYPE$$')}</label></div>
                    <div>
                        <NotificationTypeRenderer row="{issue}"/>
                    </div>
                    <div><label>{sgettext('$$PRIORITY$$')}</label></div>
                    <div>
                        <PriorityRenderer row="{issue.linked_issues.length ? issue.linked_issues[0] : null}"/>
                    </div>
                    <div><label>{sgettext('$$CODING$$')}</label></div>
                    <div>
                        <CodingRenderer row="{issue}"/>
                    </div>
                    <div><label>{sgettext('$$SAP_REFERENCE$$')}</label></div>
                    <div>{issue.linked_issues.length ? issue.linked_issues[0].notification_number : ''}</div>
                {/if}
                <div><label>{sgettext('$$ELEMENT_1$$')}</label></div>
                <div>
                    {#if issue.element_instance}
                        <a href="{`${PATH_PREFIX}/sw/elements_database/${issue.element_instance.element_id}/`}">{issue.element_instance.name}</a>
                    {/if}
                </div>
                <div><label>{sgettext('$$SEQUENCE$$')}</label></div>
                <div>
                    {#if issue.work_sequence}
                        <a href="{`${PATH_PREFIX}/sw/builder/activity_sequence_builder/${issue.activity_version.id}/worksequence/${issue.work_sequence.id}/`}">{issue.work_sequence.name}</a>
                    {/if}
                </div>
                <div><label>{sgettext('$$ACTIVITY_1$$')}</label></div>
                <div>
                    {#if issue.activity}
                        <a href="{`${PATH_PREFIX}/sw/builder/activity/${issue.activity.id}/`}">{issue.activity.name}</a>
                    {/if}
                </div>
                <div><label>{sgettext('$$ROLE$$')}</label></div>
                <div>{issue?.work_sequence?.role ? issue.work_sequence.role.name : ''}</div>
                <div><label>{sgettext('$$WORK_ORDER$$')}</label></div>
                <div>{issue.work_order ? issue.work_order : ''}</div>
                <div><label>{sgettext('$$DATE$$')}</label></div>
                <div>{moment(issue.created_date).format('MMM. DD, YYYY, hh:mm a')}</div>
                {#if issue.jira_id}
                    <div><label>{sgettext('$$JIRA_TICKET$$')}</label></div>
                    <div id="jiraId"><a href="{`${JIRA_SITE_URL}browse/${issue.jira_id}`}">{issue.jira_id}</a></div>
                {/if}
            </div>
            <div>
                <div><label>{sgettext('$$PHOTOS$$')}</label></div>
                <div class="issue-images">
                    {#each issue.images as image}
                        <div class="flag-image">
                            <Thumbnail url="{image.image_location}" media="{image.image_location}"/>
                            {#if issue.element_instance && (issue.images.length || issue.linked_images.length)}
                            <input type="checkbox" bind:group={selectedImages} value="{image.id}"/>
                            {/if}
                        </div>
                    {/each}
                    {#each issue.linked_images as image}
                        <div class="flag-image">
                            <Thumbnail url="{image.image_location}" media="{image.image_location}"/>
                            {#if issue.element_instance && (issue.images.length || issue.linked_images.length)}
                            <input type="checkbox" bind:group={selectedImages} value="{image.id}"/>
                            {/if}
                        </div>
                    {/each}
                </div>
            </div>

        </div>
        <div class="content">
            <div class="supervisor-info">
                {#if issue.last_triaged_by}
                    <div><label>{sgettext('$$DELAY_SIZE$$')}</label></div>
                    <div>
                        <DelaySizeRenderer row="{issue}"/>
                    </div>
                {/if}
                <div><label>{sgettext('$$PRIORITY$$')}</label></div>
                <div>
                    <PriorityRenderer row="{issue}"/>
                </div>
                {#if issue.last_triaged_by}
                    <div><label>{sgettext('$$COMMENTS$$')}</label></div>
                    <div>
                        {#each issue.supervisor_input as input}
                            <div>{input.comments}</div>
                        {/each}
                    </div>
                {/if}
            </div>
            {#if issue.status === flagStatus.open}
                <div class="classification-info">
                    <div><label>{sgettext('$$CLASSIFICATION$$')}</label></div>
                    <ComboSelect
                        id="selectedClassification"
                        label=""
                        placeholder="-----------"
                        options={issueClassificationTypes}
                        bind:value={selectedClassification}
                        searchable={false}
                        on:changed={saveClassification}
                        />
                </div>
            {:else if issue.status === flagStatus.closed}
                <div class="classification-info">
                    <div><label>{sgettext('$$CLASSIFICATION$$')}</label></div>
                    {#if issue.classification}
                        <span>{issue.classification}</span>
                    {:else}
                        <span>{sgettext('$$NONE$$')}</span>
                    {/if}
                </div>
            {/if}

        </div>
        <div class="content action">
            <div class="action-wrapper">
                <label>
                    {#if issue.type === flagTypes.improvement}
                       {sgettext('$$INVESTIGATION_ACTION$$')}
                    {:else if issue.type === flagTypes.help}
                        {sgettext('$$INFORMATION_1$$')}
                    {/if}
                </label>
                <ReferenceRenderer row="{issue}"/>
                {#if issue.element_instance}
                    <a href="{getElementInActivityLink()}">
                        {sgettext('$$SHOW_ELEMENT_ACTIVITY$$')}
                    </a>
                {/if}
                {#if issue.type === flagTypes.improvement}
                    <button
                            class="btn btn-primary"
                            on:click={manageIssue}
                            disabled="{!canUpdateIssue}"
                    >{issue.status === 'OPEN' ? sgettext('$$RESOLVE$$') : sgettext('$$REOPEN$$')}</button>
                    
                    {#if showReplyToReporter}
                        <button class="btn btn-primary" on:click={showReplyReporterModal}>{sgettext('$$REPLY_REPORTER$$')}</button>
                    {/if}
                {/if}

                <button
                        class="btn btn-primary"
                        on:click={add_comment}
                        disabled="{!canUpdateIssue || issue.status != 'OPEN'}"
                >{sgettext('$$ADD_COMMENT$$')}</button>

                {#if issue.element_instance && (issue.images.length || issue.linked_images.length)}
                    <Button
                            type="outline-primary"
                            name={sgettext("$$COPY_IMAGES_ELEMENT_MEDIA$$")}
                            sending="{copyingImages}"
                            disabled="{copyingImages}"
                            on:click={copyImagesToMediaLibrary}
                    />
                {/if}
            </div>
        </div>
    </div>
    {#if issue.type === flagTypes.improvement}
        <ReplyReporter id="{replyReporterModalId}" title={sgettext("$$REPLY_REPORTER$$")} issueId="{issue.id}"/>
    {/if}
{/if}
